/**
Service for fetching information about the borehole sources.
*/

import { GeoWebServiceClient } from './GeoWebServiceClient'

/**
 * The object type returned by the webservice.
 */
export interface BoreholeSource {
  Id: number
  Name: string
  Color: string
  ShortName: string
  Description: string
}

let fetchedBoreholeSources: boolean = false
const boreholeSourceDict: {[key: number]: BoreholeSource} = {}

/**
 * Service for fetching information about the borehole sources.
 */
export class DataList extends GeoWebServiceClient {
  static async getBoreholeSourceById (id: number, token: string): Promise<BoreholeSource> {
    if (!fetchedBoreholeSources) {
      // Fetch the sources now.
      const ws = new DataList(token)
      const data = await ws.fetchDataList()
      data.forEach((boreholeSource: BoreholeSource) => {
        boreholeSourceDict[boreholeSource.Id] = boreholeSource
      })
    }
    fetchedBoreholeSources = true
    if (id in boreholeSourceDict) {
      return boreholeSourceDict[id]
    } else {
      throw new Error('No source with the given id found.')
    }
  }

  static get URL (): string { return 'https://data.geo.dk/api/v3/datalist' }

  /**
   * Constructor.
   * @param token The Geo auth token.
   */
  constructor (token: string) {
    const defaultParams = {
      Datalistid: '1'
    }
    super(DataList.URL, token, defaultParams)
  }

  /**
   * Calls the web service.
   * @returns A promise bearing the nearest borehole information objects fetched.
   */
  async fetchDataList (): Promise<BoreholeSource[]> {
    const response: Response = await fetch(this.url(), { headers: { Authorization: `Bearer ${this.token}` } })
    if (!response.ok) {
      throw new Error('Got invalid HTTP response.')
    }

    const responseData = await response.json()
    return responseData
  }
}
